import licenseModule from '../../license.module';

export default licenseModule.component('licenseDeactivateDynamic', {
    template: require('./licenseDeactivateDynamic.component.html'),
    controller: ['LicenseManagementService', licenseDeactivateDynamicComponent],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licenseDeactivateDynamicComponent(LicenseManagementService) {
    var vm = this;
    vm.processing = false;

    vm.$onInit = function() {
        vm.data = vm.resolve.data;
        vm.navs = [
            {
                label: 'Deactivation',
                value: 'deactivation',
                resolve: {
                    subscription: {
                        deviceId: vm.data.usage.deviceId,
                        premiumUserId: vm.data.usage.premiumUserId
                    },
                    name: vm.data.name
                },
                component: 'licenseDeactivateDetail',
                callback: function(data) {
                    vm.eula = data.eula;
                }
            }
        ];

        vm.currentWorkflow = vm.navs[0];
        vm.eula = false;
    };

    vm.cancel = function() {
        if (!vm.processing) {
            vm.dismiss({ $value: 'cancel' });
        }
    };

    vm.deactivate = function() {
        if (!vm.processing) {
            vm.processing = true;
            LicenseManagementService.deactivateInstanceActivation(
                vm.data.id
            ).then(
                function() {
                    vm.processing = false;
                    vm.close({ $value: 'deactivate' });
                },
                function() {
                    vm.processing = false;
                    vm.close({ $value: 'deactivate' });
                }
            );
        }
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-deactivate-dynamic/licenseDeactivateDynamic.component.js